import { Component, Input } from '@angular/core';
import { ConnectionStatusEnum } from "@models/integrations/connection-status.enum";
import { HasRoleDirective } from "@shared/directives/has-role.directive";
import { LoaderComponent } from "@shared/components/commons/loader/loader.component";
import { SyncStatusEnum } from "@models/integrations/sync-status.enum";
import { IConnection } from "../integration.view.model";
import { IntegrationConnectionsEnum } from "@models/integrations/integration-connections.enum";
import { formatDate } from "@angular/common";

@Component({
  selector: 'app-connection-card',
  standalone: true,
  imports: [
    LoaderComponent,
    HasRoleDirective,
  ],
  templateUrl: 'connection-card.component.html',
  styleUrl: 'connection-card.component.scss'
})
export class ConnectionCardComponent {
  @Input({ required: true }) connection!: IConnection;
  @Input() isLoading = true;

  readonly ConnectionStatusEnum = ConnectionStatusEnum;
  readonly connectionStatusLabels: Record<ConnectionStatusEnum, string> = {
    [ConnectionStatusEnum.Connected]: 'Connected',
    [ConnectionStatusEnum.NotConnected]: 'Disconnected',
    [ConnectionStatusEnum.RequiredAction]: 'Action Required',
    [ConnectionStatusEnum.ConnectionFailed]: 'Connection Failed',
    [ConnectionStatusEnum.WaitForVerification]: 'Wait For Verification',
  };

  get showTitleInfoMessage(): boolean {
    return this.connection.connectionType === IntegrationConnectionsEnum.XpmConnection
      && this.connection.connectionStatus !== ConnectionStatusEnum.NotConnected;
  }

  get titleInfoMessage(): string {
    if (this.connection.syncStatus === SyncStatusEnum.NotSynced) {
      return 'Not Synced';
    }

    if (this.connection.syncStatus === SyncStatusEnum.Syncing) {
      return 'Syncing';
    }

    if (this.connection.syncStatus === SyncStatusEnum.Error) {
      return 'Last Full Sync: Error happaned.';
    }

    if (this.connection.syncStatus === SyncStatusEnum.Synced && this.connection.lastSync) {
      return `Last Full Sync: ${ formatDate(this.connection.lastSync, 'dd MMM yyyy HH:mm', 'en-US') }`;
    }

    return '';
  }
}
